import React from "react";

import Header from "../../components/Header";

import PaineisApropriadores from "../../components/Paineis/PaineisApropriadores";

import "./styles.css";

import {Context} from "../../AppProvider";

function TelaPaineisApropriadores() {
  return (
    <Context.Consumer>
      {(context) => (
        <div>
          <Header usuario={context.usuario} />
          <PaineisApropriadores paineis={context.paineis} usuario={context.usuario}/>
        </div>
      )}
    </Context.Consumer>
  );
}
export default TelaPaineisApropriadores;